import { useMemo } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { buildColumnDefs } from './columnFactory';
import { createBaseRegistry } from './gridRegistry/baseRegistry';

export default function ThirdFloorDataGrid({
    gridKey,
    schema,
    rows,
    pageRegistry = {},
    helperContext = {},
    overrides = {},
}) {
    const registry = useMemo(() => {
        return {
            ...createBaseRegistry(helperContext),
            ...pageRegistry,
        };
    }, [pageRegistry, helperContext]);

    const columns = useMemo(() => {
        return buildColumnDefs({
            gridKey,
            schema,
            registry,
        });
    }, [gridKey, schema, registry]);

    return (
        <DataGridPro
            columns={columns}
            rows={rows}
            disableColumnMenu
            density="compact"
            {...overrides}
        />
    );
}